/**
 * [Draft] Authz V5 
 *  # Introduction  Liste l\'ensemble des services et des opérations disponibles dans le module AUTHZ (Autorisations Pegase).   # Remarques générales sur les APIs  La plupart des opérations de l\'API nécessitent que l\'utilisateur ai le traitement correspondant, sinon elles déclencheront une erreur 403.  Le code du traitement est précisé ce document (dans la description de l\'opération)  Si l\'utilisateur n\'a pas le traitement adéquat, il faudra lui créer une habilitation sur un rôle associé au traitement ad hoc.  # Notions métiers  Le module AUTHZ permet de gérer:  * Utilisateurs * Traitements (voir Autorisation sur les Traitements) * Modules * Actions * Rôles * Habilitations * Périmètres   ## Utilisateurs  Un Utilisateur correspond à une personne ou un automate/service pouvant accèder à l\'application Pegase ou exécuter des traitements de l\'applicatif Pegase.  **Important: Note sur la création des Utilisateurs**  La création des Utilisateurs peut se faire:  * soit via la RDD (Reprise de Données). * soit via l\'applicatif REF (interface utilisateur). * soit via ce service REST /utilisateurs   ## Traitements  Un traitement identifie de manière unique une fonction unitaire de l\'application Pegase.  De manière générale, un traitement correspond à une et une seule API.  Lorsque l\'utilisateur exécute une API, l\'API vérifie que l\'Utilisateur dispose bien du traitement correspondant.  Dans le cas contraire, l\'API lui retournera une erreur (code HTTP 403).  Exemple de traitement: COF_ObjetFormation_Creer (permet de créer un Objet de Formation dans le module COF).  Les traitements sont livrés avec Pegase, il n\'est pas possible d\'en créer des nouveaux.  Par contre, une nouvelle version de Pegase peut ajouter de nouveaux traitements.  Les traitements sont au nombre de quelques centaines.  **Traitement vs Action**      Attention, si l\'API 1 appellée par un utilisateur appelle en interne une autre API (API 2), alors l\'appele ne fonctionnera que si l\'utilisateur dispose des traitements de l\'API 1 **et** de ceux de l\'API 2.  C\'est pour cela que la notion d\'Action a été inventée: une action regroupe l\'ensemble des traitements nécessaire à l\'exécution d\'un acte de gestion.   ## Actions  Une action regroupe l\'ensemble des traitements nécessaire pour réaliser un acte de gestion élémentaire.  Les actes de gestion sont livrés avec Pegase, ils ne peuvent pas être modifiés, supprimés ni créés.  Lorsqu\'un utilisateur souhaite utiliser une fonctionnalité de Pegase, il faut lui associer l\'action correspondante.  Cela se fait en associant l\'action à un rôle, puis en attributant ce rôle à un utilisateur sous la forme dune habilitation.   ## Rôle  Un rôle est un containeur d\'actions.  La notion de Rôle va permettre de regrouper les actions d\'une manière intelligible.  Cela permet de simplifier l\'administration.  L\'administrateur Authz est à même de créer, modifier et supprimer des rôles  Exemple de rôle: \'Gestionnaire de Scolarité\'   ## Habilitations  Une habilitation permet de donner un Rôle à un Utilisateur dans le cadre d\'un Groupe d\'Habilitations.  Nous reviondrons plus tard sur la notion de Groupe d\'Habilitations, pour le moment, on peut le considérer comme un périmètre de données.  Ces habilitations permettent à Pégase d\'effectuer les contrôles d\'accès:  * aux traitements +   Est ce que l\'Utilisateur a le droit d\'exécuter tel Traitement ?  ## Périmètres  Un périmètre d\'habilitation est un ensemble de données sur lequel un utilisateur associé à ce périmètre peut  agir. Dans une 1ere version, le périmètre est constitué d\'un ensemble de Formations. 
 *
 * The version of the OpenAPI document: 27.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { Erreurs } from '../model/erreurs';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedActions } from '../model/pagedActions';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class ActionsService {

    protected basePath = 'http://localhost:8080/api/authz/autorisation/v5';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Liste de toutes les actions
     * Retourne une liste paginée de rôles répondant aux critères de recherche  Traitement: AUTHZ_Action_Lire 
     * @param search Correspond à un critère de recherche d\&#39;une action sur le code ou le libellé  Si ce paramètre est précisé, retourne les actions associées à ces critères. 
     * @param code Recherche par code  Si le critère est spécifié, la recherche retourne uniquement les actions correspondant à ce code. 
     * @param pageable Données de pagination.  Le tri sur les colonnes peut se faire sur les propriétés:  * code 
     * @param withoutRole Retourne les actions qui ne sont associées à aucun rôle. 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public lireListeActions(search?: string, code?: string, pageable?: Pageable, withoutRole?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<PagedActions>;
    public lireListeActions(search?: string, code?: string, pageable?: Pageable, withoutRole?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<PagedActions>>;
    public lireListeActions(search?: string, code?: string, pageable?: Pageable, withoutRole?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<PagedActions>>;
    public lireListeActions(search?: string, code?: string, pageable?: Pageable, withoutRole?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (search !== undefined && search !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>search, 'search');
        }
        if (code !== undefined && code !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>code, 'code');
        }
        if (pageable !== undefined && pageable !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageable, 'pageable');
        }
        if (withoutRole !== undefined && withoutRole !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>withoutRole, 'withoutRole');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (idTokenAuth) required
        localVarCredential = this.configuration.lookupCredential('idTokenAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/actions`;
        return this.httpClient.request<PagedActions>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
